export const password = (value, fields) => {
	if (value && fields && value !== fields.password) {
		return 'Password must be same';
	}
};
